import { EntitlementService } from './entitlement.service';
import { HeaderService } from './header.service';
import { environment } from '../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { User } from '../User';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import {AuthService} from './auth.service';
import { CardOrder } from '../CardOrder';
import {Ship} from '../Ship';
import {ShipService} from './ship.service';
import {TransactionData} from '../data/TransactionData';

const NAVY_USER_SESSION_NAME = 'navy_user';
const LOG_VAR = 'logVar';
const TIMEOUT_VAR = 'timeoutHook';
const TIME_OUT_INTERVAL = 20 * 60 * 1000; // 20 minutes

const EXPIRING_VAR = 'expiringVar';
const EXPIRING_INTERVAL = 15 * 60 * 1000; // 15 minutes

@Injectable({
  providedIn: 'root'
})
export class SystemService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private headerService: HeaderService
  ) {}


  getCardOrders(startDate: string,
                endDate: string): Observable<CardOrder[]> {
    const url = `${environment.rootApiUrl}/common/bulkCardOrderDetails/search`;
    let params = new HttpParams();
    params = params.append('startDate', startDate || '');
    params = params.append('endDate', endDate);
    return this.http.post<CardOrder[]>(url, params, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

}
